export default __webpack_public_path__ + "static/media/FrutigerLTW02-55Roman.808c7914.woff2";